export const HttpStatusCodes = {
  Conflict: 409,
};
